<template>
	<div>
		<section class="pre-footer-bg"></section>
		<div>
			<div class="footer-border" />
			<footer>
				<div class="container">
					<div class="row">
						<div class="col-xs-12 logo-container-foot">
							<router-link to="/">
								<img
									class="img-responsive logo-foot"
									src="@/assets/images/eas-head.svg"
									alt="EAS Strategies"
								/>
							</router-link>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 text-center">
							<p>
								<a href="https://eas-strategies.com/" target="_blank"
									>EAS Strategies</a
								>
								<br class="visible-xs" />
								<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
								<a href="https://eas-strategies.com/privacy/" target="_blank"
									>Privacy policy</a
								>
								<br class="visible-xs" />
								<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
								<a href="https://eas-strategies.com/disclaimer/" target="_blank"
									>Disclaimer</a
								>
								<br />
								<br />
								© {{ currentYear }} EAS Strategies Ltd.
								<br class="visible-xs" />
								<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
								<a href="http://www.bubblegate.co.uk" target="_blank"
									>Built by Bubblegate</a
								>
							</p>
						</div>
					</div>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
export default {
	created() {
		this.getPages();
	},
	data() {
		return {
			pages: []
		};
	},
	computed: {
		currentYear: () => (new Date()).getFullYear(),
	},
	methods: {
		async getPages() {
			const { data: { data: pages } } = await this.$axios.get('/page');
			this.$set(this, 'pages', pages);
		},
	}
};
</script>
